export class GcsListPrefixesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxResults",
            "baseName": "maxResults",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcsListPrefixesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
